import { categoryList } from "./categories";

export const bconf = () => {
  return {    
    LOGIN: process.env.REACT_APP_LOGIN,
    CATEGORIES: categoryList,
    totalProductPerPage: 16,
  };
};
 